import { createDraftSafeSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { FeedbackStateType } from '../reducer/feedback.reducer'

const state = (state: RootState) => state.feedbackStore as FeedbackStateType

export const selectFeedbackStore = createDraftSafeSelector(state, (s) => s)
export const selectFeedbackCaptureRequest = createDraftSafeSelector(state, (s) => s.captureRequest)
export const selectFeedbackCapturing = createDraftSafeSelector(state, (s) => s.isCapturing)
